export const DATA_HOOKS = {
  root: 'ai-plan-recommendation-card',
  chip: 'ai-recommendation-entry-hint',
  expanded: 'ai-recommendation-expanded',
  close: 'ai-recommendation-close',
  title: 'ai-recommendation-title',
  subtitle: 'ai-recommendation-subtitle',
  cta: 'ai-recommendation-cta',
  avatar: 'ai-recommendation-avatar',
} as const;

export const ANALYZING_FLOOR_MS = 5000;
export const ANALYZING_CEILING_MS = 10000;
export const TYPING_SPEED_MS = 10;
export const BULLET_REVEAL_INTERVAL_MS = 200;
